import "core-js/modules/es.array.push.js";
import { WOW } from "wowjs";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import Axios from "axios";
export default {
  name: "index",
  computed: {
    ...walletVuex.mapState(["isMobile"]),
    wow() {
      return WOW;
    }
  },
  data() {
    const menu = [{
      label: this.$lang("About"),
      id: "About"
    }, {
      label: this.$lang("Card"),
      id: "Card"
    }, {
      label: this.$lang("Scenarios"),
      id: "Scenarios"
    }, {
      label: this.$lang("Safe"),
      id: "Safe"
    }, {
      label: this.$lang("General"),
      id: "General"
    }, {
      label: this.$lang("Api"),
      id: "api"
    }];
    const share = [{
      icon: "icon-telegram",
      type: "telegram"
    }, {
      icon: "icon-x",
      type: "x"
    }, {
      icon: "icon-discord",
      type: null
    }, {
      icon: "icon-youtube"
    }];
    const plan = [{
      mode: this.$lang("Standard"),
      type: this.$lang("Free"),
      price: "$0",
      intro: this.$lang("For the financial basics — <br>everything you need for better money management in one place. Sending money abroad or sticking to a budget has never been easier.")
    }, {
      mode: this.$lang("Plus"),
      type: this.$lang("Month"),
      price: "$3.99",
      intro: `${this.$lang("For the smart spender")} —  <br>${this.$lang("access additional benefits like better limits for spending abroad and insurance for your purchases, on our affordable paid plan.")}`
    }, {
      mode: this.$lang("Premium"),
      type: this.$lang("Month"),
      price: "$7.99",
      intro: `${this.$lang("For elevating every day")} —  <br>${this.$lang("access exclusive subscriptions, better savings rates, and exchange unlimited amounts of money.")}`
    }, {
      mode: this.$lang("Metal"),
      type: this.$lang("Month"),
      price: "$14.99",
      intro: `${this.$lang("For the global travellers and traders")} — ${this.$lang("relax with travel insurance, enjoy enhanced limits, and subscriptions worth £2,100 annually.")}`
    }];
    const general = [{
      title: this.$lang("What is MPay?"),
      label: this.$lang(`MPay is a Web3-native payment platform that lets you get a VISA card  — both virtual and physical — that can be recharged with USDT and used for online and offline purchases, just like a regular bank card.`),
      isOpen: true
    }, {
      title: this.$lang("How does the MPay Virtual Card work?"),
      label: this.$lang(`Once issued, your MPay Virtual Card functions like any online VISA card. You top it up with USDT via your connected wallet, and you can immediately use it on any online platform that accepts VISA — including e-commerce, entertainment, gaming, and travel sites.`),
      isOpen: false
    }, {
      title: this.$lang("Is MPay available globally?"),
      label: this.$lang(`The MPay Virtual Card is available in most regions worldwide. However, availability of features may vary slightly based on your jurisdiction due to regulatory considerations. The hysical Card will support global shipping in selected countries at launch.`),
      isOpen: false
    }, {
      title: this.$lang("What are the supported wallets and blockchains?"),
      label: this.$lang(`MPay supports major chains including Ethereum, BNB Chain, Solana, and TON. Wallets like MetaMask, Trust Wallet, TON Wallet, and Phantom are compatible.`),
      isOpen: false
    }, {
      title: this.$lang("Which cryptocurrencies are supported?"),
      label: this.$lang(`MPay currently supports USDT for card top-up. Support for other stablecoins like USDC and native tokens is planned for future updates.`),
      isOpen: false
    }];
    const defaultTabState = () => ({
      p3Tab: [],
      p4Tab: [],
      p3TabSelect: null,
      p4TabSelect: null,
      progress: 0,
      progressRAF: null,
      autoTimer: null,
      isProgressShow: true,
      currentIndex: 0,
      p4Timer: 4,
      isp4ImgAnim: true,
      p4ImgAnimTime: 200
    });
    return {
      menu,
      plan,
      share,
      general,
      p3: defaultTabState(),
      p4: defaultTabState(),
      isVideoShow: true
    };
  },
  watch: {
    isMobile: {
      async handler(newVal) {
        this.isVideoShow = false;
        this.p3.p3Tab = this.setP3List();
        this.p4.p4Tab = this.setP4List();
        this.p3.p3TabSelect = this.p3.p3Tab[this.p3.currentIndex];
        console.log("this.p3.p3TabSelect", this.p3.p3Tab);
        this.p4.p4TabSelect = this.p4.p4Tab[this.p4.currentIndex];
        await new Promise(resolve => setTimeout(resolve, 200));
        this.isVideoShow = true;
        this.initVideo(this.p3.p3TabSelect);
      }
    },
    "p3.p3TabSelect": {
      handler(newVal) {
        this.initVideo(newVal);
      }
    }
  },
  methods: {
    onSkip(type) {
      console.log(66666666);
      let url = null;
      if (!type) return;
      switch (type) {
        case "gw":
          url = "https://t.me/MpayCardBot";
          break;
        case "telegram":
          url = "https://t.me/MpayCardBot";
          break;
        case "x":
          url = "https://x.com/MpayCard";
          break;
        case "m_telegram":
          url = "https://t.me/MpayCardBot/?startapp=ref_sXPbRd5";
          break;
        case "m_browser":
          url = "https://app.mpay.cards?startapp=ref_sXPbRd5";
          break;
        case "m_line":
          url = "https://liff.line.me/2008536228-j92Lno4E?startapp=ref_sXPbRd5";
          break;
      }
      console.log("urlurlurlurlurl", url);
      if (!url) return;
      open(url, "target");
    },
    onMenu(item) {
      if (item.id == "api") {
        this.$router.push(`/${item.id}`);
        return;
      }
      this.isPopMenuShow = false;
      const target = document.getElementById(item.id);
      if (target) {
        target.scrollIntoView({
          behavior: "smooth"
        }); // 平滑滚动
      }
    },

    async onTabClick(key, item, index) {
      if (key == "p4") {
        this[key].isp4ImgAnim = false;
        await new Promise(resolve => setTimeout(resolve, this[key].p4ImgAnimTime));
        this[key].isp4ImgAnim = true;
      }
      this[key][`${key}TabSelect`] = item;
      this[key].currentIndex = index;
      this.startAutoSwitch(key);
      if (this.isMobile && key == "p4") this.setP4ScrollLoc(index);
    },
    initVideo(newVal) {
      this.$nextTick(() => {
        if (newVal === this.p3.p3Tab[0]) {
          const v0 = this.$refs.video0;
          if (v0) {
            v0.currentTime = 0; // 从头播放
            v0.play();
          }
        } else if (newVal === this.p3.p3Tab[1]) {
          const v1 = this.$refs.video1;
          if (v1) {
            v1.currentTime = 0;
            v1.play();
          }
        }
      });
    },
    setP3List() {
      return [{
        type: this.$lang("Virtual Card"),
        img: !this.isMobile ? require("@images/Virtual Card.mp4") : require("@images/Virtual Card w.mp4"),
        poster: !this.isMobile ? require("@images/Virtual Card p.png") : require("@images/Virtual Card w p.png"),
        tag: this.$lang("AVAILABLE NOW"),
        title: this.$lang("MPAY VIRTUAL CARD"),
        sub: this.$lang("Your Web3 VISA for the online world."),
        info: this.$lang("The MPay Virtual Card is your Web3-native VISA card that works worldwide — no delays, no friction. Just connect your wallet, recharge with USDT, and start spending online anywhere VISA is accepted — from Amazon to Netflix, Airbnb to gaming platforms."),
        time: 8
      }, {
        type: this.$lang("Physical Card"),
        img: !this.isMobile ? require("@images/Physical Card.mp4") : require("@images/Physical Card w.mp4"),
        poster: !this.isMobile ? require("@images/Physical Card p.png") : require("@images/Physical Card w p.png"),
        tag: this.$lang("Coming Soon"),
        title: this.$lang("MPAY PHYSICAL CARD"),
        sub: this.$lang("Real card. Real freedom. Real world."),
        info: this.$lang("The MPay Physical Card is coming soon — giving you the full power of Web3 in your pocket. Tap, swipe, or insert — just like any traditional VISA card, but powered 100% by your USDT balance.Whether you're shopping at local stores, traveling abroad, or dining out, your crypto finally moves with you — effortlessly."),
        time: 8
      }];
    },
    setP4List() {
      return [{
        type: this.$lang("E-commerce"),
        img: !this.isMobile ? require("@images/p4-img-1.jpg") : require("@images/wap_p4-img-1.jpg"),
        title: `${this.$lang("SPEND USDT ANYWHERE")} ${!this.isMobile ? "<br>" : ""}<i style='color:#6c81ff'>${this.$lang("INSTANTLY")}</i>`,
        sub: this.$lang("Shop on Amazon, eBay, AliExpress, or any online store that accepts VISA"),
        time: this.p4.p4Timer
      }, {
        type: this.$lang("Gaming"),
        img: !this.isMobile ? require("@images/p4-img-2.jpg") : require("@images/wap_p4-img-2.jpg"),
        title: `${this.$lang("SPEND USDT ANYWHERE")} ${!this.isMobile ? "<br>" : ""}<i style='color:#6c81ff'>${this.$lang("INSTANTLY")}</i>`,
        sub: this.$lang("Recharge in-game currencies or subscribe to platforms like Steam, Xbox, and PlayStation"),
        time: this.p4.p4Timer
      }, {
        type: this.$lang("Entertainment"),
        img: !this.isMobile ? require("@images/p4-img-3.jpg") : require("@images/wap_p4-img-3.jpg"),
        title: `${this.$lang("SPEND USDT ANYWHERE")} ${!this.isMobile ? "<br>" : ""}<i style='color:#6c81ff'>${this.$lang("INSTANTLY")}</i>`,
        sub: this.$lang("Pay for Netflix, Spotify, YouTube Premium, Disney+ and more"),
        time: this.p4.p4Timer
      }, {
        type: this.$lang("Web Services"),
        img: !this.isMobile ? require("@images/p4-img-4.jpg") : require("@images/wap_p4-img-4.jpg"),
        title: `${this.$lang("SPEND USDT ANYWHERE")} ${!this.isMobile ? "<br>" : ""}<i style='color:#6c81ff'>${this.$lang("INSTANTLY")}</i>`,
        sub: this.$lang("Use for SaaS tools like Notion, Figma, GitHub, or hosting platforms"),
        time: this.p4.p4Timer
      }, {
        type: this.$lang("Travel & Lifestyle"),
        img: !this.isMobile ? require("@images/p4-img-5.jpg") : require("@images/wap_p4-img-5.jpg"),
        title: `${this.$lang("SPEND USDT ANYWHERE")} ${!this.isMobile ? "<br>" : ""}<i style='color:#6c81ff'>${this.$lang("INSTANTLY")}</i>`,
        sub: this.$lang("Book hotels, flights, and experiences via sites like Airbnb, Booking.com, or Agoda"),
        time: this.p4.p4Timer
      }, {
        type: this.$lang("Gifting & Utilities"),
        img: !this.isMobile ? require("@images/p4-img-6.jpg") : require("@images/wap_p4-img-6.jpg"),
        title: `${this.$lang("SPEND USDT ANYWHERE")} ${!this.isMobile ? "<br>" : ""}<i style='color:#6c81ff'>${this.$lang("INSTANTLY")}</i>`,
        sub: this.$lang("Send digital gifts or pay for online bills in supported regions"),
        time: this.p4.p4Timer
      }];
    },
    setTabConfig() {
      this.p3.p3Tab = this.setP3List();
      this.p3.p3TabSelect = this.p3.p3Tab[0];
      this.p4.p4Tab = this.setP4List();
      this.p4.p4TabSelect = this.p4.p4Tab[0];
    },
    startAutoSwitch(key) {
      this.clearTimer(key);
      const listKey = `${key}Tab`;
      const selectKey = `${key}TabSelect`;
      const state = this[key];
      if (!state[listKey].length) return;
      const waitTime = (state[listKey][state.currentIndex]?.time || state.p4.p4Timer) * 1000;
      this.resetProgress(key, waitTime / 1000);
      state.autoTimer = setTimeout(async () => {
        if (key == "p4") {
          this[key].isp4ImgAnim = false;
          await new Promise(resolve => setTimeout(resolve, state.p4ImgAnimTime));
          this[key].isp4ImgAnim = true;
        }
        state.currentIndex = (state.currentIndex + 1) % state[listKey].length;
        state[selectKey] = state[listKey][state.currentIndex];
        if (this.isMobile && key == "p4") this.setP4ScrollLoc(state.currentIndex);
        this.startAutoSwitch(key);
      }, waitTime);
    },
    resetProgress(key, seconds) {
      const state = this[key];
      state.progress = 0;
      const start = performance.now();
      const duration = seconds * 1000;
      cancelAnimationFrame(state.progressRAF);
      const step = now => {
        const elapsed = now - start;
        state.progress = Math.min(elapsed / duration * 100, 100);
        if (state.progress < 100) {
          state.progressRAF = requestAnimationFrame(step);
        }
      };
      state.progressRAF = requestAnimationFrame(step);
    },
    clearTimer(key) {
      const state = this[key];
      if (state.autoTimer) clearTimeout(state.autoTimer);
    },
    setP4ScrollLoc(index) {
      this.$nextTick(() => {
        const p4ScrollRef = this.$refs.p4ScrollRef;
        if (!p4ScrollRef) return;
        const container = p4ScrollRef.children[0]; // 容器包裹元素
        const targetChild = container.children[index];
        if (!targetChild) return;
        const containerRect = p4ScrollRef.getBoundingClientRect();
        const viewportWidth = window.innerWidth;

        // 子元素相对容器左侧的偏移
        const childOffsetLeft = targetChild.offsetLeft;
        // 子元素宽度
        const childWidth = targetChild.offsetWidth;

        // 计算子元素中心点距离容器左侧的距离
        const childCenterPos = childOffsetLeft + childWidth / 2;

        // 滚动目标 = 子元素中心点 - 屏幕中心点
        const scrollTarget = childCenterPos - viewportWidth / 2;
        p4ScrollRef.scrollTo({
          top: 0,
          left: scrollTarget,
          behavior: "smooth"
        });
      });
    },
    async getChannelSource() {
      let source = document.referrer?.trim();
      let _localhost = location.href.split("#")[0];
      const http_post = "https://xapi.mpay.cards";
      let referrer = {
        source: null,
        localhost: null
      };
      try {
        const isLocal = location.hostname === "localhost" || location.hostname === "127.0.0.1" || /^\d{1,3}(\.\d{1,3}){3}$/.test(location.hostname);
        if (isLocal) {
          referrer.source = "local";
          referrer.localhost = "local";
        } else if (!source) {
          referrer.source = _localhost;
          referrer.localhost = _localhost;
        } else {
          referrer.source = source;
          referrer.localhost = _localhost;
        }
        if (referrer.source == "local") {
          return;
        }
        const response = await fetch(`${http_post}/www/webmaster`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            source: referrer.source,
            localhost: referrer.localhost
          })
        });
        const data = await response.json();
        console.log(data);
      } catch (error) {
        console.error(error);
      }
    }
  },
  mounted() {
    const wow = new this.wow({
      live: true
    });
    wow.init();
    this.setTabConfig();
    this.startAutoSwitch("p3");
    this.startAutoSwitch("p4");
    this.getChannelSource();
  },
  beforeDestroy() {
    this.clearTimer("p3");
    this.clearTimer("p4");
  }
};